import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 w-full" }
const _hoisted_2 = { class: "w-full bg-white p-6 rounded-md shadow-md flex flex-wrap gap-2 items-center justify-between" }
const _hoisted_3 = { class: "font-[800] text-neutral-900" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.questionCount) + "." + _toDisplayString(" " + _ctx.question?.prompt), 1),
      (_ctx.playAudio)
        ? (_openBlock(), _createBlock(_component_MessageVoice, {
            key: 0,
            msg: _ctx.msgVoice(_ctx.question.prompt),
            scaleIcons: 0.8,
            showIconsName: false,
            onOnEndMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSpeak($event)))
          }, null, 8, ["msg", "scaleIcons"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processedItems, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "mb-6 last:mb-0 bg-white p-6 rounded-md shadow-md flex flex-col sm:flex-row sm:items-center gap-2"
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.renderLetterItem(index)), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.parts, (part, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (part.type === 'text')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: part.content
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createBlock(_component_InputText, {
                  key: 1,
                  modelValue: part.inputText,
                  "onUpdate:modelValue": ($event: any) => ((part.inputText) = $event),
                  maxlength: "255"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}